<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Opera
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Opera</strong> generated $46.0m in revenue and attracted close to 0.4m attendances.</p>
          <p>Among all categories, <strong>Opera</strong> recorded the second-highest y-o-y growth in revenue of 48.0% (from $31.1m in 2024 to $46.0m in 2025) and attendance of 33.2% (from 0.3m in 2024 to 0.4m in 2025).</p>
          <p>The y-o-y increase in average ticket price of 7.1% (from $130.28 in 2024 to $139.59 in 2025) also contributed to the growth in revenue. It is likely that revenue and average ticket prices have increased to offset rising production and touring costs.</p>
          <p>In 2025, <strong>Opera</strong> revenue returned to pre-pandemic levels; however, attendance has not returned to pre-pandemic levels.</p>
          <p>Major <strong>Opera</strong> performances in 2025 included <em>Carmen</em>, <em>Cinderella</em>, <em>La Traviata</em>, <em>Great Opera Hits</em>, <em>The Barber of Seville</em> and La Bohème.</p>
          <p>Similar to previous years, performances by NPAP companies including Opera Australia, Opera Queensland, West Australian Opera, Victorian Opera and State Opera South Australia contributed the majority to the overall revenue (90.4%) and attendance (87.3%) in this category in 2025.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW and VIC generated the most revenue and attendance in this category. These two states generated 90.7% of overall revenue and 84.4% of attendance in this category in 2025.</p>
          <p>NSW recorded a y-o-y growth in revenue (50.6%) and attendance (35.0%) in 2025. Major <strong>Opera</strong> performances in NSW included <em>Carmen</em>, <em>Cinderella, La Traviata</em>, <em>Great Opera Hits</em> and <em>The Barber of Seville</em>.</p>
          <p>VIC recorded a y-o-y growth in revenue (63.6%) and attendance (29.8%) in 2025. Major <strong>Opera</strong> performances in VIC included <em>Carmen</em>, <em>The Barber of Seville</em>, <em>Orpheus &amp; Eurydice</em> and <em>The Verdi Gala Concert</em>.</p>
          <p>WA recorded a y-o-y growth in revenue (63.8%) and attendance (75.9%) in 2025. Major <strong>Opera</strong> performances in WA included <em>Madama Butterfly</em>, <em>The Pirates of Penzance</em> and <em>Il Trovatore</em>.</p>
          <p>All states and territories except QLD and SA recorded a y-o-y growth in revenue and attendance in 2025.</p>
        </div>

        <p style="font-size: .8em;text-align: center;">Note: Data for <strong>Opera</strong> performances that were presented as part of a multi-artform festival will be captured in <strong>Festivals (Multi-Category).</strong></p>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/OPERA  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Opera Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Carmen - Danielle de Niese and Abraham Bretón</em>, Opera Australia, Photo Credit: Jeff Busby</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [62.562, 46.391, 48.331, 47.249, 41.317, 44.044, 40.129, 47.306, 47.844, 43.284, 42.621, 41.505, 46.248, 36.349, 46.965, 40.202, 11.314, 15.649, 23.662, 39.944, 31.079, 46.012],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.63, 0.532, 0.516, 0.592, 0.403, 0.448, 0.41, 0.439, 0.431, 0.345, 0.387, 0.433, 0.408, 0.369, 0.487, 0.436, 0.148, 0.151, 0.225, 0.321, 0.267, 0.356],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 76.9],
            ["VIC", 13.8],
            ["QLD", 0.3],
            ["WA", 5.2],
            ["SA", 2.5],
            ["ACT", 1.2],
            ["TAS", 0.1],
            ["NT", 0.1],
          ],
          attendance: [
            ["NSW", 67.2],
            ["VIC", 17.2],
            ["QLD", 2.1],
            ["WA", 7.1],
            ["SA", 3.4],
            ["ACT", 2.0],
            ["TAS", 0.3],
            ["NT", 0.7],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/27-Opera-Danielle-de-Niese-and-Abraham-Bretón-in-Opera-Australia's-production-of-Carmen-at-Regent-Theatre,-Melbourne.-Photo-by-Jeff-Busby-(1).jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
